module.exports = __webpack_public_path__ + "img/users-up.908814df.svg";